import { Component, OnInit, Inject, ViewChild, ElementRef, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { FormValidatorService } from '../../shared-services/form-validator.service';
import { HistoryProvider } from '../../core/browser-providers';
import { MediaService } from '../../shared-services/media.service';
import { Http } from '@angular/http';
import { NavigationService } from '../../shared-services/navigation.service';
import { NgForm } from '@angular/forms';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { MotivosRechazo } from './motivosRechazo.model';

@Component({
  selector: 'app-motivosRechazo-add-edit',
  templateUrl: './motivosRechazo-add-edit.component.html',
  styleUrls: ['./motivosRechazo-add-edit.component.scss']
})
export class MotivosRechazoAddEditComponent implements OnInit {

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  @ViewChild('form') public roleForm: NgForm;

  validationFail = false;
  motivosRechazo: MotivosRechazo;

  messageTitle: string;

  isHD = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private snackService: SnackService,
    private backendService: BackendService,
    private formValidatorService: FormValidatorService,
    @Inject(HistoryProvider) private history: History,
    private http: Http,
    private mediaService: MediaService,
    private navigationService: NavigationService,
    private dialogService: DialogService,
  ) { }

  ngOnInit() {

    this.route.data.subscribe(data => {
      this.motivosRechazo = data.user;
      this.motivosRechazo.description = this.motivosRechazo.id ? this.motivosRechazo.description : '';
    });

    this.messageTitle = this.motivosRechazo.id  ? 'Edición de motivos de rechazo' : 'Alta de motivos de rechazo';

    this.mediaService.isHighDefinition.subscribe(isHD => this.isHD = isHD);
  }

  back() {
    this.navigationService.back();
  }

  async save() {
    if (this.validateForm()) {
      this.invokeSave();
    }
  }

  validateForm() {
    let validationsOK = false;

    // Valida el resto de los controles con sus validadores
    if (this.formValidatorService.isFormValid(this.roleForm)) {
      validationsOK = true;
      this.validationFail = false;
    } else {
      validationsOK = false;
      this.validationFail = true;
    }

    return validationsOK;
  }

  private async invokeSave() {

    if (this.validateForm()) {
      this.ConfirmSave();
    }

    return;
  }

  async ConfirmSave() {
    this.dialogService.confirm(this.messageTitle,
    '¿Está seguro que desea guardar el motivos de rechazo ' + this.motivosRechazo.description + '?')
    .then( res => {
      if (res) {
        this.saveMotivosRechazo(res);
      }
    });
  }

  async saveMotivosRechazo(res) {
    if (res) {

      this.snackService.spinner(true);

      if (this.motivosRechazo.id) { // Update
        try {
          await await this.backendService.update(MotivosRechazo.path + this.motivosRechazo.id, this.motivosRechazo);
          this.snackService.success('Motivos de rechazo editados');
          this.router.navigate(['/motivosRechazo']);
        } catch (ex) {
          this.snackService.error(ex.message);
        } finally {
          this.snackService.spinner(false);
        }
      } else {
        try {
          await this.backendService.create(MotivosRechazo.path, this.motivosRechazo);
          this.snackService.success('Motivos de rechazo creados');
          this.router.navigate(['/motivosRechazo']);
        } catch (ex) {
          this.snackService.error(ex.message);
        } finally {
          this.snackService.spinner(false);
        }
      }
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/cliente/motivosRechazo/motivosRechazo-add-edit.component.ts